import { defineMessages } from 'react-intl';

const _default_1: {
	betaLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	infoIconLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	atlassianIntelligenceCopyrightShort: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	atlassianIntelligenceCopyright: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	rovoCopyright: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	/**
	 * https://hello.atlassian.net/wiki/spaces/AAI/pages/5055352099/Footer+guidelines+for+AI+Updated+Mar+2025
	 * Updated Mar 2025
	 * However this is put behind a feature flag along with a11y updates.
	 * Can use this as a default once the feature flag is removed, make sure to get rid of disclaimerTextShort & disclaimerText
	 * See thread: https://atlassian.slack.com/archives/C04039CJ003/p1743571543775729
	 */
	disclaimerTextUpdated: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	usePageKnowledgeToggleLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	compactFeedbackText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	betaLabel: {
		id: 'fabric.editor.ai.screens.preview.betaLabel',
		defaultMessage: 'Beta',
		description: 'The label describing the beta status of the Atlassian Intelligence feature',
	},
	infoIconLabel: {
		id: 'fabric.editor.ai.commandPalette.footer.infoIconLabel',
		defaultMessage: 'Information',
		description: 'The label for the information icon',
	},
	atlassianIntelligenceCopyrightShort: {
		id: 'fabric.editor.ai.commandPalette.footer.atlassianIntelligenceCopyrightShort',
		defaultMessage: 'Powered by AI',
		description:
			'Text to display in the right part of Editor AI command palette footer in short form for AI requests',
	},
	atlassianIntelligenceCopyright: {
		id: 'fabric.editor.ai.commandPalette.footer.atlassianIntelligenceCopyright',
		defaultMessage: 'Powered by Atlassian Intelligence',
		description:
			'Text to display in the right part of Editor AI command palette footer for AI requests',
	},
	rovoCopyright: {
		id: 'fabric.editor.ai.commandPalette.footer.rovoCopyright',
		defaultMessage: 'Rovo',
		description:
			'Text to display in the right part of Editor AI command palette footer for Rovo requests',
	},
	/**
	 * https://hello.atlassian.net/wiki/spaces/AAI/pages/5055352099/Footer+guidelines+for+AI+Updated+Mar+2025
	 * Updated Mar 2025
	 * However this is put behind a feature flag along with a11y updates.
	 * Can use this as a default once the feature flag is removed, make sure to get rid of disclaimerTextShort & disclaimerText
	 * See thread: https://atlassian.slack.com/archives/C04039CJ003/p1743571543775729
	 */
	disclaimerTextUpdated: {
		id: 'fabric.editor.ai.commandPalette.footer.disclaimerTextUpdated',
		defaultMessage: 'Uses AI. Verify results.',
		description: 'Text to display in the disclaimer part of Editor AI command palette footer',
	},
	usePageKnowledgeToggleLabel: {
		id: 'fabric.editor.ai.commandPalette.footer.usePageKnowledgeToggleLabel',
		defaultMessage: 'Include knowledge from current page',
		description:
			'Label for the toggle to enable or disable the use of page knowledge in AI requests',
	},
	compactFeedbackText: {
		id: 'fabric.editor.ai.screens.preview.compactFeedbackText',
		defaultMessage: 'Helpful?',
		description:
			'Label and prompter text to induce users to click neighbouring thumbs up or down feedback buttons',
	},
});
export default _default_1;
